import type { FC } from "react";
import { useAppSelector } from "../../hooks/hook.js";
import { selectCompanyCompetitorsTracker } from "../keywordTrackers/keywordTrackersSlice.js";
import { KeywordTrackerEditor } from "./keywordTrackerEditor.js";
import { settingsSections } from "./settingsSections.js";
import { SettingsSectionPage } from "./shared/settingsSection.js";

export const KeywordTrackersSettingsSection: FC = () => {
  const competitorsTracker = useAppSelector(selectCompanyCompetitorsTracker);

  return (
    <SettingsSectionPage title={settingsSections.keywordTrackers.label}>
      <div className="pb-4 text-sm text-muted-foreground">
        Keyword Trackers allow you to monitor specific phrases in interviews.
      </div>
      {competitorsTracker ? (
        <KeywordTrackerEditor
          key={`keyword-tracker-editor-${competitorsTracker.id}`}
          keywordTracker={competitorsTracker}
        />
      ) : null}
    </SettingsSectionPage>
  );
};
